import { useAVRDrawer } from "@/contexts/AVRDrawerContext";

const FILLED = { high: 4, medium: 3, low: 2, insufficient: 0 };

export function ConfidenceIndicator({ level = "medium", limitedBy }) {
  const filled = FILLED[level] ?? 3;
  const { openAVR } = useAVRDrawer() || {};
  return (
    <span className="inline-flex items-center gap-1.5" data-testid={`confidence-${level}`}>
      <span className="inline-flex gap-[2px]">
        {[0, 1, 2, 3].map((i) => (
          <span
            key={i}
            className="w-[3px] h-3 rounded-sm"
            style={{ backgroundColor: i < filled ? "var(--oim-text-secondary)" : "var(--oim-surface-softer)" }}
          />
        ))}
      </span>
      <span className="text-[9px] font-heading uppercase tracking-wide text-[var(--oim-text-muted)]">{level}</span>
      {limitedBy && (
        <button
          type="button"
          className="text-[9px] font-mono-data text-[var(--oim-gold)] underline underline-offset-2"
          data-testid={`confidence-limiter-${limitedBy}`}
          onClick={() => openAVR && openAVR(limitedBy)}
        >
          ⚠ {limitedBy}
        </button>
      )}
    </span>
  );
}
